import { Platform } from 'react-native';

import { ModalProps } from 'react-native-modal';

import { PlayerTracks } from 'store/player/reducer.types.ts';

import { COLOR } from 'utils/colors.ts';
import {
    ORIENTATION,
    lockToDefaultOrientation,
    lockToLandscape,
    lockToLandscapeLeft,
    lockToLandscapeRight,
} from 'utils/orientation.ts';
import {
    switchImmersiveModeOff,
    switchImmersiveModeOn,
} from 'utils/systemUI.ts';

import { StartoverStreamType } from 'screens/PlayerModal/types.ts';

export const DEFAULT_SO_STREAM_DELAY_FROM_LIVE = 5;

export function onBeforeShowPlayerModal(orientation?: ORIENTATION) {
    if (orientation === ORIENTATION.LANDSCAPE_LEFT) {
        lockToLandscapeLeft();
    } else if (orientation === ORIENTATION.LANDSCAPE_RIGHT) {
        lockToLandscapeRight();
    } else {
        lockToLandscape();
    }

    switchImmersiveModeOn();
}

export function onAfterHidePlayerModal() {
    switchImmersiveModeOff();
    lockToDefaultOrientation();
}

const supportedOrientations: ModalProps['supportedOrientations'] = [
    'portrait',
    'landscape',
    'landscape-left',
    'landscape-right',
];

export const modalProps: Partial<ModalProps> = {
    statusBarTranslucent: true,
    hasBackdrop: true,
    useNativeDriver: Platform.OS !== 'web',
    useNativeDriverForBackdrop: true,
    hideModalContentWhileAnimating: true,
    animationIn: 'fadeIn',
    animationOut: 'fadeOut',
    animationInTiming: 200,
    animationOutTiming: 400,
    backdropColor: COLOR.BLACK,
    supportedOrientations,
};

export function isAudioAndSubtitles(tracks: PlayerTracks | undefined) {
    return (
        tracks &&
        (tracks.audioTracks.length > 1 || tracks.textTracks.length > 1)
    );
}

export async function enterWebFullscreen(playerElementId: string) {
    const videoElement = document.getElementById(playerElementId);

    if (videoElement) {
        await videoElement.requestFullscreen();
    }
}

export async function exitWebFullscreen() {
    if (document.fullscreenElement !== null) {
        await document.exitFullscreen();
    }
}

export const STARTOVER_STREAM_TYPE = Platform.select<StartoverStreamType>({
    android: 'static',
    default: 'dynamic',
});

export function isStartoverStreamStatic(type: StartoverStreamType) {
    return type === 'static';
}

export function isStartoverStreamDynamic(type: StartoverStreamType) {
    return type === 'dynamic';
}
